import React from 'react';
import styles from './ServiceProviders.module.css';
import image1 from '../../Images/1.png'
import image2 from '../../Images/2.png'
import image3 from '../../Images/3.png'
import image4 from '../../Images/4.png'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import Spinner from 'react-bootstrap/Spinner';

const ServiceProviders = ({onCardClick , servicesId ,servicesId2 , isEdit, reservationNum,isEditServisePreducer, cartFromCart}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
console.log("reservationNum",reservationNum)
const onSubmit = (card) =>{
  console.log("card",card)
  localStorage.setItem("empCard", JSON.stringify(card));
  navigate("/time", {
    state: {
      isEdit: isEdit,
      servicesId:servicesId,
      servicesId2:servicesId2,
      reservationNum:reservationNum,
      isEditServisePreducer:{isEditServisePreducer},
      cartFromCart:{cartFromCart}
    },
  })
}
const Serviceproviders = useSelector((state) => state.ServicesSlice.Serviceproviders);
const isLoading = useSelector((state) => state.ServicesSlice.isLoading);

console.log("Serviceproviders", Serviceproviders)
  return (
    <>
   {isLoading ?

   <div style={{display:"flex", justifyContent:"center"}}>

   <Spinner animation="border" role="status" style={{width:"100px", height:"100px"}}/>
   </div>:
   <div>

   { Serviceproviders && Serviceproviders?.length > 0 ? <div className={styles.cardContainer} >
      {Serviceproviders && Serviceproviders?.map((card) => (
        <div key={card.empi_num} className={styles.card} onClick={()=>{onSubmit(card)}}>
          {/* <img src={card.emp_img.trim() ? card.emp_img.trim() :image1 } alt={card.emp_namar} className={styles.cardImage} /> */}
          <img src={`https://reservation.ladycaresa.com/public/uploads${card?.emp_img}`} alt={card.emp_namar} className={styles.cardImage} />
          <div className={styles.cardLabel}>
            <span>
            {currentLanguage === "ar"
    ? card.emp_namar.trim() // Arabic branch name
    : card.emp_namen.trim() || card.emp_namar.trim() // English branch name (fallback to Arabic if empty)
  }
            </span>
          </div>
        </div>
      ))}
    </div> :
     <div style={{
      display:"flex",
      justifyContent:"center",
      alignItems:"center",
      fontSize:"28px",
      fontWeight:"900",
      margin:"70px"
    }}>{t('ThereAreNoServicesProducersAvailable')} </div> 
    }
   </div>
    }
    </>
  );
};

export default ServiceProviders;
